var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M20.0475 16.4728C18.8437 14.9995 17.9939 14.2495 17.9939 10.1878C17.9939 6.46826 16.0945 5.1431 14.5312 4.49951C14.3236 4.4142 14.1281 4.21826 14.0648 4.00498C13.7906 3.0717 13.0219 2.24951 12 2.24951C10.9781 2.24951 10.2089 3.07217 9.93748 4.00592C9.8742 4.22154 9.67873 4.4142 9.47108 4.49951C7.90592 5.14404 6.00842 6.46451 6.00842 10.1878C6.00608 14.2495 5.15624 14.9995 3.95249 16.4728C3.45374 17.0831 3.89061 17.9995 4.76296 17.9995H19.2417C20.1094 17.9995 20.5434 17.0803 20.0475 16.4728Z",
          stroke: "black",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15 17.9988V18.7488C15 19.5444 14.6839 20.3075 14.1213 20.8701C13.5587 21.4327 12.7956 21.7488 12 21.7488C11.2043 21.7488 10.4413 21.4327 9.87868 20.8701C9.31607 20.3075 9 19.5444 9 18.7488V17.9988",
          stroke: "black",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }